<template>
  <div>
    <SkillHead v-if="programId !== 1"/>
    <!-- 跆拳道 -->
    <SkillTaekwondo v-if="programId === 1"/>
    <!-- 空手道 -->
    <SkillKarate v-else-if="programId === 2"/>
    <!-- 兵道 -->
    <SkillRuse v-else-if="programId === 12"/>
    <SkillCareer/>
  </div>
</template>

<script>
import SkillHead from './module/SkillHead'
//跆拳道
import SkillTaekwondo from './module/SkillTaekwondo'
//兵道
import SkillRuse from './module/SkillRuse'
//空手道
import SkillKarate from './module/SkillKarate'
import SkillCareer from './module/SkillCareer'
export default {
  components: {
    SkillHead,
    SkillTaekwondo,
    SkillCareer,
    SkillRuse,
    SkillKarate
  },
  data () {
    return {
      programId: Number(this.$route.query.programId)
    }
  },
  created () {
    window.scrollTo(0, 0)
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/components/PlayerDetail.vue